export const GOOGLE_OAUTH_CONFIG = {
  clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '',
  clientSecret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET ?? '',
};

export const GOOGLE_SCOPES = [
  'openid',
  'profile',
  'email',
]; 